import React, { useState, useEffect} from 'react';
import { getInvoiceById, uploadInvoiceImage } from '../../store/action/invoice';
import ReactLoading from "react-loading";
import {PDFViewer, PDFDownloadLink} from '@react-pdf/renderer'
import Invoice from '../../components/templates/pdfs/Invoice'
import moment from 'moment';
import { UploadButton } from '../../components/buttons';
import { isAuthenticated } from '../../store/action/auth';
import { Button } from '../../components/buttons';
import formatter from './formatter';

const PublicInvoice = (props) => {
    const [loading, setLoading ] = useState(true)
    const [invoiceReady, setInvoiceReady ] = useState(false)
    const [loadingImage, setLoadingImage] = useState(false)
    const { user, token } = isAuthenticated();
    const [invoice, setInvoice] = useState({})
    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const { invoiceId } = props.match.params
            const res = await getInvoiceById( token, invoiceId );
            if (res.success) {
                setInvoice({
                    id:res.id,
                    invoiceNo: res.reference_id,
                    userId: res.bill_to_user_id,
                    name: res.bill_to_name,
                    company: res.bill_to_company,
                    email: res.bill_to_email,
                    phone: res.bill_to_phone,
                    address: res.bill_to_address,
                    period: res.period,
                    issueDate: moment(res.issued_at).format('DD MMMM YYYY'),
                    dueDate: moment(res.due_at).format('DD MMMM YYYY'),
                    status:res.status,
                    items: res.items,
                    paidOrderBill: res.paid_order_bill,
                    total: res.total
                })
            } else {
                alert(res.error)
            }
            setLoading(false);
        } catch (e) {
            console.log (e);
            alert("Gagal ambil data akun. Mohon ulangi kembali.")
        }
    };

    const onUploadPaymentImage = async (data) => {
        setLoadingImage(true)
        const res = await uploadInvoiceImage(token, invoice.id, data);
        if(res.success) {
            alert("Bukti pembayaran telah diupload");
            window.location.reload()
        } else {
            alert("Bukti pembayaran gagal diupload. Coba ulangi lagi yuk!")
            setLoadingImage(false)
        }
    }

    if (loading) {
        return (
            <div className="text-center row">
              <div className="col-3"/>
              <div className="row col-5 py-5">
                <ReactLoading
                    type={'bubbles'}
                    color={'#459BD8'}
                    height={54}
                    width={75}
                />
                <h5 className="mt-4 "><strong> Memuat Invoice... </strong></h5>
              </div>
              <div className="col-4"/>
            </div>
        );
    }
    return (
        <div className="text-center mt-3 pt-4">
            <div className="row" style={{width:'80%',marginLeft:'auto',marginRight:'auto'}}>
                {
                    invoiceReady ? 
                        <PDFDownloadLink className="col-4 btn btn-primary" document={ <Invoice invoice={formatter.invoiceToPDF(invoice)} />} fileName={`[${invoice.company}] Biteship Invoice - #${invoice.invoiceNo}.pdf`}>
                            {({ blob, url, loading, error }) => (loading ? 'Memuat...' : 'Download Invoice')}
                        </PDFDownloadLink>
                        :
                        <button className="col-4 btn btn-outline-primary" onClick={() => setInvoiceReady(true)}>
                            Export Invoice
                        </button>
                }
                
                <div className="col-1"/>
                {
                    invoice.status !== 'active' ? 
                        <div className="col-4"/>
                        :
                        <div className="col-4">
                            {
                                loadingImage ? 
                                    <Button loading={true} className="btn btn-outline-primary">
                                        Mengupload...
                                    </Button>   
                                    :
                                    <UploadButton title={"Upload Proof of Payment"} handleFile={data => onUploadPaymentImage(data)}/>   
                            }
                        </div>
                        
                }
                
                <div className="col-3">
                    <h3 className={`${invoice.status === 'active' ? "text-danger" : 
                        invoice.status === 'pending' ? "text-warning" : 
                        invoice.status === 'paid' ? "text-success" :
                        invoice.status === 'void' ? "text-muted" : "text-danger"}`}>
                        <strong>
                            {   
                                invoice.status === 'active' ? "AKTIF" : 
                                invoice.status === 'pending' ? "PENDING" : 
                                invoice.status === 'paid' ? "✅ PAID" :
                                invoice.status === 'void' ? "VOID" : null
                            }
                        </strong>
                    </h3>
                </div>
                
            </div>
           <PDFViewer width="80%" height="800" className="mt-5" >
                <Invoice invoice={formatter.invoiceToPDF(invoice)} />
            </PDFViewer>
        </div>
    )
};

export default PublicInvoice;
